import React, { Component } from "react";
import PropTypes from "prop-types";
//import { configure, BarcodePicker as ScanditSDKBarcodePicker } from "scandit-sdk";
import * as ScanditSDK from "scandit-sdk";
import { SetComponentLanguage } from '../../../helpers';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Message from '../../Common/Message/Message';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class BarcodePicker extends Component {
  	static propTypes = {
		visible: PropTypes.bool,
		playSoundOnScan: PropTypes.bool,
		vibrateOnScan: PropTypes.bool,
		scanningPaused: PropTypes.bool,
		guiStyle: PropTypes.string,
		videoFit: PropTypes.string,
		scanSettings: PropTypes.object,
		enableCameraSwitcher: PropTypes.bool,
		enableTorchToggle: PropTypes.bool,
		enableTapToFocus: PropTypes.bool,
		enablePinchToZoom: PropTypes.bool,
		accessCamera: PropTypes.bool,
		camera: PropTypes.object,
		cameraSettings: PropTypes.object,
		targetScanningFPS: PropTypes.number,
		onScan: PropTypes.func,
		onError: PropTypes.func
  	};

  	constructor(props) {
    	super(props);
    	this.ref = React.createRef();

        this.state = {
        	scandItSupported: true
        }
  	}

	componentDidMount() {
        //this.loadScanditScript();
		ScanditSDK.configure(process.env.REACT_APP_SCANDIT_API_KEY, {
			engineLocation: "https://unpkg.com/scandit-sdk/build"
		}).then(() => {
			ScanditSDK.BarcodePicker.create(this.ref.current, this.props)
			.then(barcodePicker => {
				this.barcodePicker = barcodePicker;
				if (this.props.onScan != null) {
					barcodePicker.on('scan', this.props.onScan);
				}
				if (this.props.onError != null) {
					barcodePicker.on('scanError', this.props.onError);
				}
			});
		}).catch(error => {
            console.log("Scandit error");
            console.log(error);
            // if (error.name === 'UnsupportedBrowserError') {
				this.setState({ scandItSupported: false });
			// }
        });

		
        console.log(process.env.REACT_APP_SCANDIT_API_KEY);
	}

	componentWillUnmount() {
		if (this.barcodePicker != null) {
		this.barcodePicker.destroy();
		}
	}

	componentDidUpdate(prevProps) {
		// These are just some examples of how to react to some possible property changes

		if (JSON.stringify(prevProps.scanSettings) !== JSON.stringify(this.props.scanSettings)) {
		this.barcodePicker.applyScanSettings(this.props.scanSettings);
		}

		if (prevProps.visible !== this.props.visible) {
		this.barcodePicker.setVisible(this.props.visible);
		}
	}

	loadScanditScript = () => {
		console.log('loadScanditScript')
        // Configure the library and activate it with a license key
		ScanditSDK.configure(process.env.REACT_APP_SCANDIT_API_KEY, {
            engineLocation: "https://unpkg.com/scandit-sdk/build"
        }).catch(error => {
            console.log("Scandit error");
            console.log(error);
            // if (error.name === 'UnsupportedBrowserError') {
				this.setState({ scandItSupported: false });
			// }
        });
	}

  	render() {
    	return (
			<div>
            	{!this.state.scandItSupported &&
				<div className="container">
					<Message
						message={
                        	{
                            	title: window.general_strings.msg.warning,
                            	content: strings.notSupported,
                            	type: 'error'
                        	}
                    	}
					/>
				</div>
            	}
    			<div ref={this.ref} />
			</div>
		);
  	}
}

export default BarcodePicker;


// WEBPACK FOOTER //
// ./src/components/Checkin/BarcodePicker/BarcodePicker.js